<template>
  <div class="simulativeTset-view-shell">
      <div class="w-view-shell">
          <!-- 面包屑  -->
          <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="'/'">首页</el-breadcrumb-item>
              <el-breadcrumb-item>开始学习</el-breadcrumb-item>
              <el-breadcrumb-item>模拟练习</el-breadcrumb-item>
          </el-breadcrumb>

          <!-- 侧边栏 -->
          <div class="simulativeTset-content-shell">
              <div class="simulativeTset-content">
                  <div class="list-shell">
                      <div class="list-box handler" @click="go_test(0)">
                          <span>
                            {{year}}年专业科目模拟练习1
                          </span>
                      </div>
                      <div class="list-box handler" @click="go_test(1)">
                          <span>
                            {{year}}年专业科目模拟练习2
                          </span>
                      </div>
                      <div class="list-box handler" @click="go_test(2)">
                          <span>
                            {{year}}年专业科目模拟练习3
                          </span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'simulativeTset',
  data () {
    return {
      year: ''
    }
  },
  props: {
    
  },
  mounted () {
    if (this.$route.query.year) {
      this.year = this.$route.query.year
    }
  },
  methods: {
    go_test (num) { // 购买 //测试
      this.$router.push('/lianxi?num=' + num + "&year=" + this.year)
    },
  }
}
</script>

<style lang="less" scoped>
  .simulativeTset-view-shell {
      width: 100%;
      min-height: 100vh;
      background-color: #f4f4f4;
      .page {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
  }

  .simulativeTset-content-shell {
      display: flex;
      width: 100%;

      .simulativeTset-sider {
          min-width: 284px;
          background: #fff;

          .sider-box {
              display: flex;
              align-items: center;
              padding: 20px;
              font-size: 26px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              height: 100px;
          }

          .sider-box-active {
              color: #2AA9B5;
              border-left: 4px solid #2AA9B5;
          }
      }

      .simulativeTset-content {
          flex: 1;
          margin-left: 10px;

          .list-shell {
              .list-box {
                  display: flex;
                  align-items: center;
                  height: 92px;
                  background-color: #fff;
                  margin-bottom: 12px;
                  padding: 20px;
                  position: relative;
                  font-size: 24px;
                  font-family: Microsoft YaHei;
                  font-weight: bold;
                  color: #090909;

                  .is-pay {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: absolute;
                      top: 0px;
                      left: 0px;
                      width: 49px;
                      height: 30px;
                      background-color: red;
                      color: #fff;
                      font-size: 12px;
                      border-bottom-right-radius: 8px;
                  }
              }
          }
      }
  }

  .no-data {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 20vh;
      width: 50vw;
      color: orange;
      font-size: 24px;
  }

  .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
      font-weight: 400;
      color: #000;
      cursor: text;
  }

  .el-breadcrumb {
      height: 47px;
      line-height: 47px;
      font-size: 16px;
      margin: 20px 0;
  }

  /deep/ .el-tabs__item.is-active {
      color: #2aa9b5;
      font-size: 26px;
  }

  /deep/ .el-tabs--left .el-tabs__item.is-left {
      text-align: right;
      font-size: 26px;
      margin-top: 34px;

  }

  /deep/ .el-tabs__active-bar {
      background-color: #2aa9b5;
  }

  /deep/ .el-tabs {
      height: 800px;
      position: relative;
  }

  .van-icon-arrow::before {
      content: "\F00A";
      margin-top: 16px;
  }

  .titleClass {
      width: 394px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #090909;
      margin-left: 10px;
      line-height: 54px;
  }

  .pay {
      position: absolute;
      top: 0;
      left: 0;
  }

  .van-cell--clickable {
      cursor: pointer;
      margin-left: 20px;
  }
</style>
